<script setup>
import { useRoute } from 'vue-router';

const route = useRoute();

document.title = route.query.title;
</script>

<template>
  <div class="h-100vh w-100vw overflow-hidden">
    <video class="h-full w-full" controls :src="route.query.videoUrl" />
  </div>
</template>
